import React from "react"
import { useTranslation } from "react-i18next"
import { Button, Box, FormControl, useTheme, makeStyles, TextField, Typography } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
	margin: {
		margin: 0,
	},
	selected: {
		backgroundColor: theme.palette.primary.dark,
		pointerEvents: "none",
	},
	hoverDisplay: {
		"&:hover": {
			backgroundColor: theme.palette.primary.dark,
		},
		"&:hover .hoverText": {
			color: `${theme.palette.primary.contrastText} !important`,
		},
	},
}))

const AllDocuments = ({ onClickHandler, activeTab = "all_documents" }) => {
	const [t] = useTranslation("global")
	const theme = useTheme()
	const classes = useStyles()
	return (
		<>
			<Button
				variant="text"
				size="small"
				className={`${classes.margin} ${activeTab === "all_documents" ? classes.selected : classes.hoverDisplay}`}
				onClick={activeTab !== "all_documents" ? onClickHandler : null}
				style={{ height: "38px", marginTop: "9px" }}
			>
				<Typography
					style={{
						...theme.typography.body1,
						fontWeight: theme.typography.fontWeightMedium,
						textTransform: "capitalize",
						...(activeTab === "all_documents"
							? { color: theme.palette.primary.contrastText }
							: { color: theme.palette.text.primary }),
					}}
					nowrap
					className={`typography-ellipsis hoverText`}
				>
					{t("filterConceptDropdown.all_documents")}
				</Typography>
			</Button>
		</>
	)
}

export default AllDocuments
